import { Button } from "@/components/ui/button";
import {
  ArrowRight,
  BarChart3,
  CheckSquare,
  DollarSign,
  FileText,
} from "lucide-react";

interface Categoria {
  id: string;
  titulo: string;
  icon: React.ComponentType<{ className?: string }>;
  /** Classe de cor do ícone — usa os tokens do tema, não cores soltas. */
  corIcone: string;
  perguntas: string[];
}

const categorias: Categoria[] = [
  {
    id: "tecnicas",
    titulo: "Consultas técnicas",
    icon: FileText,
    corIcone: "text-primary",
    perguntas: [
      "Norma para assentamento de piso cerâmico",
      "Espessura mínima de laje para vão de 5 m",
    ],
  },
  {
    id: "custos",
    titulo: "Custos e orçamentos",
    icon: DollarSign,
    corIcone: "text-success",
    perguntas: [
      "Custo médio do m² de alvenaria em SP",
      "Comparar gasto de areia entre as obras",
    ],
  },
  {
    id: "dados",
    titulo: "Dados das suas obras",
    icon: BarChart3,
    corIcone: "text-warning",
    perguntas: [
      "Status e avanço da obra",
      "Quantos dias impraticáveis neste mês?",
    ],
  },
  {
    id: "acoes",
    titulo: "Ações no sistema",
    icon: CheckSquare,
    corIcone: "text-primary",
    perguntas: [
      "Criar tarefa: comprar portas para amanhã",
      "Resumir o RDO de ontem em um parágrafo",
    ],
  },
];

interface QuickSuggestionsProps {
  onSuggestionClick: (suggestion: string) => void;
}

export const QuickSuggestions = ({ onSuggestionClick }: QuickSuggestionsProps) => {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {categorias.map((categoria) => {
        const Icone = categoria.icon;

        return (
          <section
            key={categoria.id}
            className="flex flex-col gap-1.5 rounded-lg border border-border bg-card p-3.5"
          >
            <header className="mb-1 flex items-center gap-2">
              <Icone className={`h-4 w-4 shrink-0 ${categoria.corIcone}`} />
              <h3 className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
                {categoria.titulo}
              </h3>
            </header>

            {categoria.perguntas.map((pergunta) => (
              <Button
                key={pergunta}
                variant="ghost"
                onClick={() => onSuggestionClick(pergunta)}
                className="group h-auto min-h-11 w-full justify-between gap-2 whitespace-normal px-2.5 py-2 text-left text-sm font-normal leading-snug"
              >
                <span>{pergunta}</span>
                <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
              </Button>
            ))}
          </section>
        );
      })}
    </div>
  );
};
